import React from 'react';
import PropTypes from 'prop-types';
import { CtaButton } from '@web/molecules';
import { StyledCTAGroupComponent, CTAButtonWrapper } from './styles.js';

export const CTAGroup = ({ ctas = [], buttonsPerRow = 2 }) => {
  return (
    <StyledCTAGroupComponent $buttonsPerRow={buttonsPerRow}>
      {ctas.map((cta, index) => (
        <CTAButtonWrapper key={index}>
          <CtaButton
            headerText={cta.headerText}
            variant={cta.variant}
            href={cta.href}
            icon={cta.icon}
            iconAlignment={cta.iconAlignment}
            triggerModal={cta.triggerModal}
            modal={cta.modal}
            openNewTab={cta.openNewTab}
          >
            {cta.children}
          </CtaButton>
        </CTAButtonWrapper>
      ))}
    </StyledCTAGroupComponent>
  );
};

CTAGroup.displayName = 'CTAGroup';

CTAGroup.propTypes = {
  ctas: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.node.isRequired,
      href: PropTypes.string.isRequired,
      variant: PropTypes.string,
      ctaVariant: PropTypes.string,
      icon: PropTypes.string,
      iconAlignment: PropTypes.oneOf(['left', 'right']),
      headerText: PropTypes.string,
      triggerModal: PropTypes.bool,
      modal: PropTypes.object,
    }),
  ),
  buttonsPerRow: PropTypes.number,
};
